import * as larvitar from "larvitar/dist/larvitar";

const csTools = larvitar.cornerstoneTools;
const getNewContext = csTools.importInternal("drawing/getNewContext");
const draw = csTools.importInternal("drawing/draw");
const drawJoinedLines = csTools.importInternal("drawing/drawJoinedLines");
const drawHandles = csTools.importInternal("drawing/drawHandles");

class FreehandRoiNoTextTool extends csTools.FreehandRoiTool {
  constructor(props = {}) {
    super(props);
    this.name = "FreehandRoiNoText";
  }

  renderToolData(evt) {
    const toolData = csTools.getToolState(evt.currentTarget, this.name);
    if (!toolData) return;

    const eventData = evt.detail;
    const { element } = eventData;
    const { renderDashed } = this.configuration;
    const lineDash = csTools.getModule("globalConfiguration").configuration
      .lineDash;
    const context = getNewContext(eventData.canvasContext.canvas);
    const config = this.configuration;

    for (let i = 0; i < toolData.data.length; i++) {
      const data = toolData.data[i];
      if (data.visible === false || !data.handles) continue;

      draw(context, context => {
        let color, fillColor;
        if (data.active) {
          color = data.handles.invalidHandlePlacement
            ? config.invalidColor
            : csTools.toolColors.getColorIfActive(data);
          fillColor = data.handles.invalidHandlePlacement
            ? config.invalidColor
            : csTools.toolColors.getFillColor();
        } else {
          color = csTools.toolColors.getColorIfActive(data);
          fillColor = csTools.toolColors.getToolColor();
        }

        const options = { color };
        if (renderDashed) options.lineDash = lineDash;

        if (data.handles.points.length) {
          const points = data.handles.points;
          drawJoinedLines(context, element, points[0], points, options);

          if (data.polyBoundingBox) {
            drawJoinedLines(
              context,
              element,
              points[points.length - 1],
              [points[0]],
              options
            );
          } else if (config.mouseLocation && config.mouseLocation.handles) {
            drawJoinedLines(
              context,
              element,
              points[points.length - 1],
              [config.mouseLocation.handles.start],
              options
            );
          }
        }

        // Draw handles
        const handleOpts = { color, fill: fillColor };
        if (
          config.alwaysShowHandles ||
          (data.active && data.polyBoundingBox)
        ) {
          handleOpts.handleRadius = config.activeHandleRadius;
          if (config.drawHandles) {
            drawHandles(context, eventData, data.handles.points, handleOpts);
          }
        }

        if (data.canComplete) {
          handleOpts.handleRadius = config.completeHandleRadius;
          if (config.drawHandles) {
            drawHandles(
              context,
              eventData,
              [data.handles.points[0]],
              handleOpts
            );
          }
        }

        if (data.active && !data.polyBoundingBox) {
          handleOpts.handleRadius = config.activeHandleRadius;
          if (config.drawHandles && config.mouseLocation) {
            drawHandles(
              context,
              eventData,
              config.mouseLocation.handles,
              handleOpts
            );
            drawHandles(
              context,
              eventData,
              [data.handles.points[0]],
              handleOpts
            );
          }
        }
      });
    }
  }
}

export default FreehandRoiNoTextTool;
